export default __webpack_public_path__ + "static/IEYC-mobile-5e7c166f9636ae16cb98209209627cae.png";